import React, {useCallback, useRef} from 'react';
import t from 'babel-plugin-yate/macro';
import get from 'lodash-es/get';

import {ANAF_CODE} from '../../config/employmentStatuses';
import errorFocus from '../../lib/errorFocus';
import {
  defaultAddress,
  getCurrentStoredAddressLabel,
} from '../../config/cardDeliveryAddressHelpers';

import Button from '../../components/Button';
import AdditionalInformationForm from './AdditionalInformationForm';

function Step3(props) {
  const formRef = useRef();
  const {data, patchHandler, uuid, status} = props;
  const isPersonalNeeds = data.type === 5;

  const handleAdditionalInformationFormData = useCallback(
    async values => {
      const incomeUploaded =
        data?.customer?.professional_status[0]?.code === ANAF_CODE ||
        (status !== 'anaf_ok' &&
          data?.checklist?.income_uploaded === 'uploaded');
      const bankStatementUploaded =
        data?.checklist?.bank_statement_uploaded === 'uploaded';
      let payload = values;

      if (!incomeUploaded) {
        return;
      }

      if (
        isPersonalNeeds &&
        values.payment === 'iban' &&
        !bankStatementUploaded
      ) {
        return;
      }

      const cardDeliveryAddressId = get(
        values,
        'customer.card_data.address_type',
      );
      const cardDeliveryAddressLabel = getCurrentStoredAddressLabel(
        values,
        cardDeliveryAddressId,
      );

      if (cardDeliveryAddressLabel !== defaultAddress.default) {
        payload = {
          ...payload,
          customer: {
            ...payload?.customer,
            card_data: {
              ...payload?.customer?.card_data,
              card_address: get(
                payload,
                `customer.${cardDeliveryAddressLabel}`,
              ),
            },
          },
        };
      }

      patchHandler(payload);
    },
    [data, patchHandler, status, isPersonalNeeds],
  );

  return (
    <div className="relative">
      <AdditionalInformationForm
        disabled={false}
        handleAction={handleAdditionalInformationFormData}
        formRef={formRef}
        initialValues={{
          customer: {
            ...(data?.customer ?? {}),
            professional_status: Boolean(
              data?.customer?.professional_status.length,
            )
              ? data.customer.professional_status
              : [
                  /**
                   * if the 'professional_status' is not received from Altex or MediaGalaxy,
                   * 'Employee with ANAF' is checked by default
                   * */
                  {code: ANAF_CODE},
                ],
            political: {
              ...(data?.customer?.political ?? {}),
              is_exposed: data?.customer?.political?.is_exposed ?? false,
            },
            employment: {
              ...(data?.customer?.employment ?? {}),
              permanent_contract: !Boolean(
                data?.customer?.employment?.job_ends_at,
              ),
              job_ends_at: data?.customer?.employment?.job_ends_at ?? null,
            },
          },
          detail: {
            ...(data.detail ?? {}),
          },
          isCorrespondenceAddressSameAsId: true,
          isResidenceAddressSameAsId: true,
          products: data.products,
          payment: data.payment,
        }}
        patchHandler={patchHandler}
        requestStatus={data.status}
        uuid={uuid}
        type={data.type}
        showDeliveryAddressCcValue={data.show_delivery_address_cc}
        showRefinancingCreditsForm={data.show_refinancing_credits}
      />

      <div className="py-6 flex justify-between">
        <div className="w-64 mx-auto sm:mr-0">
          <Button
            fullWidth
            color="orange"
            border={false}
            title={t`Continue`}
            onClick={() => {
              errorFocus(formRef.current);

              formRef.current.dispatchEvent(
                new Event(
                  'submit',
                  /**
                   * https://github.com/facebook/react/issues/12639
                   */
                  {cancelable: true},
                ),
              );
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Step3;
